module.exports = __webpack_public_path__ + "static/media/baaa_chandrabindu.75eb920e.ogg";